module.exports = __webpack_public_path__ + "img/swap.39aaeb4e.svg";